<script setup lang="ts">
  import { useLocalStorage } from '@vueuse/core';

  const props = defineProps<{
    /** Unique key persisting the dismissal in localStorage. */
    storageKey: string;
    /** Already-translated note text. */
    text: string;
  }>();

  const dismissed = useLocalStorage(
    `stats-scope-note:${props.storageKey}`,
    false
  );

  const dismiss = () => {
    dismissed.value = true;
  };
</script>

<template>
  <v-alert
    v-if="!dismissed"
    class="stats-scope-note"
    text
    dense
    color="blue-grey"
    icon="mdi-information-outline"
  >
    <div class="note-content">
      <span class="note-text">{{ text }}</span>
      <v-btn
        class="dismiss-btn"
        icon
        x-small
        color="blue-grey"
        :aria-label="String($t('close'))"
        @click="dismiss"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
  </v-alert>
</template>

<style scoped lang="scss">
  .stats-scope-note {
    @apply tw-mb-4;

    .note-content {
      @apply tw-flex tw-items-start tw-justify-between tw-gap-2;

      .note-text {
        @apply tw-text-sm;
      }

      .dismiss-btn {
        @apply tw-flex-shrink-0;
      }
    }
  }
</style>
